type ResultError = string | Error

export type TFailedResult<E extends Error | string = ResultError> = { status: 'fail'; error: E }

export type TResult<T, E extends Error | string = ResultError> =
  | { status: 'success'; result: T }
  | TFailedResult<E>

export const Result = {
  ok<T> (result: T) {
    return { status: 'success' as const, result }
  },
  fail<E extends Error | string = string> (error: E) {
    return { status: 'fail' as const, error }
  },
  combine (results: TResult<unknown>[]): TResult<unknown> {
    for (let i = 0; i < results.length; i += 1) {
      const resultItem = results[i]
      if (resultItem.status === 'fail') return resultItem
    }
    return Result.ok(undefined)
  },
  encase:
    <T, A extends unknown[]>(fn: (...args: A) => T) =>
    (...args: A): TResult<T, string | Error> => {
      try {
        return Result.ok<T>(fn(...args))
      } catch (e) {
        if (typeof e === 'string' || e instanceof Error) {
          return Result.fail(e)
        }
        return Result.fail('unknown type of error')
      }
    },
}
